<form [formGroup]="criteria">
    <div class="validated-form-field-container flex-container">
        <mat-checkbox class="flex-item" formControlName="shouldDoCreditPhoneWaterfallValidation" 
            data-testid="credit-phone-waterfall-validation-checkbox" (change)="toggleCreditPhoneWaterfall($event.checked)">
            {{ 'common.labels.creditBureauAndPhoneValidationWaterfall' | transloco }}
        </mat-checkbox>
        <lib-error-bubble [control]="criteria.controls['shouldDoCreditPhoneWaterfallValidation']"
            [message]="shouldDoCreditPhoneWaterfallValidationErrors$"></lib-error-bubble>
    </div>
    <div class="validated-form-field-container flex-container">
        <mat-checkbox (change)="setUIConfiguration()" class="flex-item" formControlName="shouldDoCreditBureauValidation" data-testid="credit-bureau-validation-checkbox">
            {{ 'common.labels.creditBureauValidation' | transloco }}
        </mat-checkbox>
        <lib-error-bubble [control]="criteria.controls['shouldDoCreditBureauValidation']"
            [message]="shouldDoCreditBureauValidationErrors$"></lib-error-bubble>
    </div>
    <div class="validated-form-field-container flex-container">
        <mat-checkbox (change)="setUIConfiguration()" class="flex-item" formControlName="shouldDoPhoneNumberValidation" data-testid="phone-number-validation-checkbox">
            {{ 'common.labels.phoneNumberVerification' | transloco }}
        </mat-checkbox>
        <lib-error-bubble [control]="criteria.controls['shouldDoPhoneNumberValidation']"
            [message]="shouldDoPhoneNumberValidationErrors$"></lib-error-bubble>
    </div>
    <div class="validated-form-field-container flex-container">
        <mat-checkbox (change)="setUIConfiguration()" class="flex-item" formControlName="shouldDoIdentityVerification" data-testid="identity-verification-checkbox">
            {{ 'orders.documentVerificationWithBiometrics' | transloco }}
        </mat-checkbox>
        <lib-error-bubble [control]="criteria.controls['shouldDoIdentityVerification']"
            [message]="shouldDoIdentityVerificationErrors$"></lib-error-bubble>
    </div>
    @if (criteria.get('shouldDoIdentityVerification')?.value) {
        <div class="flex-container idv-language-container">
            <span class="flex-item">{{ 'orders.dvsLanguage' | transloco }}</span>
        </div>
        <div class="flex-container idv-language-container">
            <mat-radio-group formControlName="sendIdvInFrench">
                <mat-radio-button class="radio-button" [value]="false">{{ 'common.labels.english' | transloco }}</mat-radio-button>
                <mat-radio-button class="radio-button" [value]="true">{{ 'common.labels.french' | transloco }}</mat-radio-button>
            </mat-radio-group>
        </div>
    }
    @if (shouldShowPepsAndSanctions) {
    <div class="validated-form-field-container flex-container">
        <mat-checkbox class="flex-item" (change)="setUIConfiguration()" formControlName="shouldDoPepsAndSanctions" data-testid="peps-and-sanctions-checkbox">
            {{ 'orders.pepsAndSanctionsCheck' | transloco }}
        </mat-checkbox>
        <lib-error-bubble [control]="criteria.controls['shouldDoPepsAndSanctions']"
            [message]="shouldDoPepsAndSanctionsErrors$"></lib-error-bubble>
    </div>
    }
</form>